const useClearSpecialCharacters = (str) => str
  .toString()
  .replace(',', '')
  .replace('.', '')
  .replace('@', '')
  .replace('/', '');

export default useClearSpecialCharacters;
